


//--------------------------------
//  タブ切り替え 施工事例 リノベーション
//--------------------------------
jQuery(function($){
    $('.tab').click(function(){
        // クリックした要素の先祖要素の中で、classの値が.works_single__renovationの要素を取得
        const group = $(this).parents('.works_single__renovation');
        group.find('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        group.find('.is-show').removeClass('is-show');
        // クリックしたタブからインデックス番号を取得
        const index = $(this).index();
        // クリックしたタブと同じインデックス番号をもつコンテンツを表示
        group.find(".panel").eq(index).addClass('is-show');
    });
});

//--------------------------------
//  タブ切り替え 採用情報　募集要項
//--------------------------------
jQuery(function($){
    $('.recruitment__tab--item').click(function(){
        // クリックした要素の先祖要素の中で、classの値が.recruitment_groupの要素を取得
        const group = $(this).parents('.recruitment_group');
        group.find('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        group.find('.is-show').removeClass('is-show');
        // クリックしたタブからインデックス番号を取得
        const index = $(this).index();
        // クリックしたタブと同じインデックス番号をもつコンテンツを表示
        group.find(".panel").eq(index).addClass('is-show');
    });
});


